import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["typedInput", "styleButton"]

  connect() {
    this.drawnSection = document.getElementById("drawn-signature-section")
    this.typedSection = document.getElementById("typed-signature-section")
    this.typeInput = document.getElementById("signature-type-input")
  }

  switchToDrawn() {
    this.drawnSection.classList.remove("hidden")
    this.typedSection.classList.add("hidden")
    this.typeInput.value = "drawn"
    
    // Update tab styles
    this.updateTabs("drawn")
  }

  switchToTyped() {
    this.drawnSection.classList.add("hidden")
    this.typedSection.classList.remove("hidden")
    this.typeInput.value = "typed"
    
    // Update tab styles
    this.updateTabs("typed")
  }

  updateTabs(activeTab) {
    const tabs = document.querySelectorAll(".signature-tab")
    tabs.forEach(tab => {
      if ((activeTab === "drawn" && tab.textContent.includes("Draw")) ||
          (activeTab === "typed" && tab.textContent.includes("Type"))) {
        tab.classList.add("border-blue-500", "text-blue-600")
        tab.classList.remove("border-transparent", "text-gray-500")
      } else {
        tab.classList.remove("border-blue-500", "text-blue-600")
        tab.classList.add("border-transparent", "text-gray-500")
      }
    })
  }
}
